'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var Spinner = function Spinner(props) {
    var componentClass = (0, _classnames2['default'])('Spinner', 'Spinner-' + props.size + '-' + props.type, props.className);
    return _react2['default'].createElement('div', { className: componentClass, id: props.id });
};

Spinner.propTypes = {
    className: _propTypes2['default'].string,
    id: _propTypes2['default'].string,
    size: _propTypes2['default'].oneOf(['sm', 'md', 'lg']),
    type: _propTypes2['default'].oneOf(['primary', 'inverted'])
};

Spinner.defaultProps = {
    type: 'primary',
    size: 'sm'
};

module.exports = Spinner;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Spinner.js
// module id = 301
// module chunks = 0